import { DatabaseService, RepositoryHost } from "@/core";
import { getAccountIssueRepository } from "./account-issue-repository";
import { getClientRepository } from "./client-repository";
import { getNoteTemplateRepository } from "./note-template-repository";
import { getSpecialAttributeRepository } from "./special-attribute-repository";
import { getVendorRepository } from "./vendor-repository";
import { getAuditLogRepository } from "./audit-log-repository";
import { getBookingRepository } from "./booking-repository";
import { getConfigRepository } from "./config-repository";
import { getCustomerMetricsRepository } from "./customer-metrics-repository";
import { getCustomerRepository } from "./customer-repository";
import { getDealRepository } from "./deal-repository";
import { getEventRepository } from "./event-repository";
import { getInventoryRepository } from "./inventory-repository";
import { getInventoryLedgerRepository } from "./inventory-ledger-repository";
import { getInvoiceRepository } from "./invoice-repository";
import { getOrderCandidateRepository } from "./order-candidate-repository";
import { getMercuryBalanceSnapshotRepository } from "./mercury-balance-snapshot-repository";
import { getMercuryPaymentRepository } from "./mercury-payment-repository";
import { getAirwallexBalanceSnapshotRepository } from "./airwallex-balance-snapshot-repository";
import { getAirwallexPaymentRepository } from "./airwallex-payment-repository";
import { getPaymentRepository } from "./payment-repository";
import { getPaypalPaymentRepository } from "./paypal-payment-repository";
import { getProductRepository } from "./product-repository";
import { getBlockedContactRepository } from "./blocked-contact-repository";
import { getPromoCodeRepository } from "./promo-code-repository";
import { getPurchaseOrderRepository } from "./purchase-order-repository";
import { getReportRepository } from "./report-repository";
import { getSalesOrderRepository } from "./sales-order-repository";
import { getStockCheckRepository } from "./stock-check-repository";
import { getUserRepository } from "./user-repository";

export const repositoryHost: RepositoryHost = {
    getClientRepository: (databaseService: DatabaseService) =>
    getClientRepository(databaseService),
getConfigRepository: (databaseService: DatabaseService) =>
    getConfigRepository(databaseService),
  getPromoCodeRepository: (databaseService: DatabaseService) =>
    getPromoCodeRepository(databaseService),
  getBlockedContactRepository: (databaseService: DatabaseService) =>
    getBlockedContactRepository(databaseService),
  getUserRepository: (databaseService: DatabaseService) =>
    getUserRepository(databaseService),
  getProductRepository: (databaseService: DatabaseService) =>
    getProductRepository(databaseService),
  getEventRepository: (databaseService: DatabaseService) =>
    getEventRepository(databaseService),
  getCustomerRepository: (databaseService: DatabaseService) =>
    getCustomerRepository(databaseService),
  getDealRepository: (databaseService: DatabaseService) =>
    getDealRepository(databaseService),
  getInventoryRepository: (databaseService: DatabaseService) =>
    getInventoryRepository(databaseService),
  getCustomerMetricsRepository: (databaseService: DatabaseService) =>
    getCustomerMetricsRepository(databaseService),
  getAuditLogRepository: (databaseService: DatabaseService) =>
    getAuditLogRepository(databaseService),
  getReportRepository: (databaseService: DatabaseService) =>
    getReportRepository(databaseService),
  getOrderCandidateRepository: (databaseService: DatabaseService) =>
    getOrderCandidateRepository(databaseService),
  getPurchaseOrderRepository: (databaseService: DatabaseService) =>
    getPurchaseOrderRepository(databaseService),
  getSalesOrderRepository: (databaseService: DatabaseService) =>
    getSalesOrderRepository(databaseService),
  getBookingRepository: (databaseService: DatabaseService) =>
    getBookingRepository(databaseService),
  getStockCheckRepository: (databaseService: DatabaseService) =>
    getStockCheckRepository(databaseService),
  getAccountIssueRepository: (databaseService: DatabaseService) =>
    getAccountIssueRepository(databaseService),
  getInvoiceRepository: (databaseService: DatabaseService) =>
    getInvoiceRepository(databaseService),
  getPaymentRepository: (databaseService: DatabaseService) =>
    getPaymentRepository(databaseService),
  getPaypalPaymentRepository: (databaseService: DatabaseService) =>
    getPaypalPaymentRepository(databaseService),
  getMercuryPaymentRepository: (databaseService: DatabaseService) =>
    getMercuryPaymentRepository(databaseService),
  getMercuryBalanceSnapshotRepository: (databaseService: DatabaseService) =>
    getMercuryBalanceSnapshotRepository(databaseService),
  getAirwallexPaymentRepository: (databaseService: DatabaseService) =>
    getAirwallexPaymentRepository(databaseService),
  getAirwallexBalanceSnapshotRepository: (databaseService: DatabaseService) =>
    getAirwallexBalanceSnapshotRepository(databaseService),
  getInventoryLedgerRepository: (databaseService: DatabaseService) =>
    getInventoryLedgerRepository(databaseService),
  getVendorRepository: (databaseService: DatabaseService) =>
    getVendorRepository(databaseService),
  getNoteTemplateRepository: (databaseService: DatabaseService) =>
    getNoteTemplateRepository(databaseService),
  getSpecialAttributeRepository: (databaseService: DatabaseService) =>
    getSpecialAttributeRepository(databaseService),
};
